import React from 'react';
import { Helmet } from 'react-helmet';
import { useMetadata } from 'gatsby-theme-carbon/src/util/hooks';

const Meta = ({ pageTitle, pageDescription, pageKeywords, pageData, titleType }) => {
  const { title, description, keywords, lang } = useMetadata();
  
  console.log('Meta component received:', { pageTitle, pageDescription, pageKeywords, pageData });

  const getPageTitle = () => {
    switch (titleType) {
      case 'page':
        // use site title for fallback
        return pageTitle || title;
      case 'site':
        return title;
      case 'append':
        return `${title}${pageTitle ? ` – ${pageTitle}` : ''}`;
      case 'prepend':
        return `${pageTitle ? `${pageTitle} – ` : ''}${title}`;
      default:
        return null;
    }
  };

  const getJsonLd = (data) => {
    const website = {
      "@context": "http://www.schema.org",
      "@type": "WebSite",
      "name": "Hegen Marketplace",
      "alternateName": "Hegen",
      "url": "https://hegen.ru/"
    };
    const organization = {
      "@context": "http://www.schema.org",
      "@type": "Organization",
      "name": "Hegen",
      "url": "https://hegen.ru",
      "sameAs": [
        "https://www.hegen.ru"
      ],
      "description": "Hegen marketplace",
      "openingHours": "Mo, Tu, We, Th, Fr, Sa, Su -"
    };
    let product = "";
    if (data && data.type === 'product') {
      product =
      {
        "@context": "http://schema.org/",
        "@type": "Product",
        "name": `${data.name}`,
        "image": `${data.image}`,
        "description": `${data.description}`,
        "sku": `${data.article}`,
        "mpn": `${data.article}`,
        "brand": {
          "@type": "Brand",
          "name": `${data.brand}`
        },
        "offers": {
          "@type": "AggregateOffer",
          "priceCurrency": `${data.priceCurrency}`,
          "lowPrice": `${data.lowPrice}`,
          "highPrice": `${data.highPrice}`,
          "offerCount": `${data.offerCount}`,
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "5",
          "ratingCount": "5",
          "reviewCount": "1"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "DMG"
            },
            "reviewBody": "Very Nice!"
          }
        ]
      };
    }
    return [website, organization, product];
  }

  const finalTitle = getPageTitle();
  const finalDescription = pageDescription || description;
  const finalKeywords = pageKeywords || keywords;
  
  // console.log('Final meta values:', { finalTitle, finalDescription, finalKeywords });
  
  return (
    <Helmet
      title={finalTitle}
      meta={[
        {
          name: 'description',
          content: finalDescription,
        },
        {
          name: 'keywords',
          content: finalKeywords,
        },
      ]}>

      <script type='application/ld+json'>{JSON.stringify(getJsonLd(pageData))}</script>
      <meta charset="utf-8" />
      {/* <meta name="robots" content="noindex, nofollow" /> */}
      <html lang={lang} />
    </Helmet>
  );
};

export default Meta;
